import React from "react";

import { useAuth } from "../contexts/AuthContext";

/**
 * Says, once and plainly, that this session is showing sanitised data.
 *
 * This matters MORE since prices became stand-in figures rather than blanks
 * (2026-09-24). A blank price column cannot be mistaken for a real price; a
 * plausible `$5,628.52` can, and someone could walk out of a demo quoting it.
 * The banner leads with that, then explains the stand-in labels -- a part
 * reading `PART-418823` or a rig reading `Work Center 214` would otherwise
 * look like a broken catalogue.
 *
 * It is NOT a security control. The server has already masked the payload by
 * the time this renders — this only narrates it. Hiding the banner would not
 * unmask anything.
 */
export const SanitizedBanner: React.FC = () => {
  const { masked, isAuthenticated } = useAuth();
  if (!isAuthenticated || !masked) return null;

  return (
    <div
      role="status"
      className="bg-warning-50 border-b border-warning-200 px-4 py-2 text-xs text-warning-900"
    >
      <span className="font-medium">Sanitised view — the figures below are not real.</span>{" "}
      Fleet health, states and activity are genuine. Prices, customer and vendor
      names, part numbers, part descriptions and work-center names are all
      replaced with consistent stand-ins — the same part or customer reads the
      same way on every screen, and totals add up, but none of the values are
      the real ones.
    </div>
  );
};

export default SanitizedBanner;
